import { render } from "./EnPowerAccountSwitch.vue?vue&type=template&id=8f45aa1e&scoped=true&ts=true"
import script from "./EnPowerAccountSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnPowerAccountSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./EnPowerAccountSwitch.vue?vue&type=style&index=0&id=8f45aa1e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f45aa1e"],['__file',"Shared/components/navigation/EnPowerAccountSwitch/EnPowerAccountSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f45aa1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f45aa1e', __exports__)) {
    api.reload('8f45aa1e', __exports__)
  }
  
  module.hot.accept("./EnPowerAccountSwitch.vue?vue&type=template&id=8f45aa1e&scoped=true&ts=true", () => {
    api.rerender('8f45aa1e', render)
  })

}


export default __exports__